import { render } from "./AddTaxeModal.vue?vue&type=template&id=20717eb6&ts=true"
import script from "./AddTaxeModal.vue?vue&type=script&lang=ts"
export * from "./AddTaxeModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__